/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  IStaticPageContentMethods,
  StaticPageContentService,
  GetBoxesService,
  IGetBoxesMethods,
  CreateOrderService,
  ICreateOrderTypeMethods,
  IGetInvoicePdfTypeMethods,
  GetInvoicePdfService,
  UpdateDelegateNameService,
  IUpdateDelegateNameMethods,
  IGetBoxesYearMethods,
  GetBoxesYearService,
  ICreatePayFACMethods,
  CreatePayFACService,
  IValidateDiscountMethods,
  ValidateDiscountService,
  BrandDetailsService,
  IBrandDetailsMethods,
  IGetCitiesMethods,
  GetCitiesService,
  IUpdateBoxMethods,
  UpdateBoxService,
  IGetMyDiscountMethods,
  GetMyDiscountService,
  CreateMultiBoxService,
  ICreateMultiBoxMethods,
} from "./components";

export type PurchasedCostumePageAgent = IStaticPageContentMethods &
  IGetBoxesMethods &
  ICreateOrderTypeMethods &
  IUpdateDelegateNameMethods &
  IGetBoxesYearMethods &
  ICreatePayFACMethods &
  IGetInvoicePdfTypeMethods &
  IValidateDiscountMethods &
  IUpdateBoxMethods &
  IGetCitiesMethods &
  IGetMyDiscountMethods &
  ICreateMultiBoxMethods &
  IBrandDetailsMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new GetBoxesService(),
    new CreateOrderService(),
    new GetInvoicePdfService(),
    new UpdateDelegateNameService(),
    new GetBoxesYearService(),
    new CreatePayFACService(),
    new UpdateBoxService(),
    new GetCitiesService(),
    new ValidateDiscountService(),
    new GetMyDiscountService(),
    new BrandDetailsService(),
    new CreateMultiBoxService(),
  ];
};

export const getAgent = () => {
  return createAgent<PurchasedCostumePageAgent>({
    plugins: getPlugins(),
  });
};
